import React, { HTMLAttributes, ReactNode } from "react";
import arrowRightImg from "../img/test-arrow-icon.svg";
import plusIcon from "../img/test-icon-plus.svg";
import timesIcon from "../img/test-times-icon.svg";
import "./_button.scss";
import { colors } from "../variable";
export interface ButtonProps extends HTMLAttributes<HTMLButtonElement> {
  type?: "btn-extended" | "btn-plus" | "btn-cancel" | "btn-icon" | "";
  onClick?: () => void;
  style?: React.CSSProperties;
  className?: string | undefined;
  label?: string | undefined;
  color: colors["value"];
  size?: "small" | "big" | undefined;
  textColor?: colors["value"];
  disabled?: true | false;
  loading?: true | false;
  children?: ReactNode;
  // loaderColor?: string | undefined;
  purpleGradient?: true | false;
  loaderText?: string;
}

const RazorButton = ({
  className,
  label,
  onClick,
  style,
  type,
  color,
  size,
  textColor,
  disabled,
  loading,
  children,
  // loaderColor,
  purpleGradient,
  loaderText,
}: ButtonProps) => {
  if (type === "btn-extended") {
    return (
      <button
        style={style}
        onClick={() => {
          if (!disabled && !loading) onClick?.();
        }}
        className={`raven-btn btn-extended btn-${color || "green-light"}   ${
          size === "small" ? "btn-sm" : size === "big" ? "btn-lg" : "btn-md"
        } text-${textColor || "white-light"} ${className} ${
          purpleGradient && "btn_purple_gradient"
        } ${disabled && "btn_disabled"} `}
      >
        <figure className="img-box-two">
          <img src={plusIcon} alt="" className="img" />
        </figure>
        {label}
        {children}
      </button>
    );
  }
  if (type === "btn-plus") {
    return (
      <button
        style={style}
        onClick={() => {
          !disabled && !loading && onClick && onClick();
        }}
        className={`raven-btn btn-${color || "green-light"} btn-rounded text-${
          textColor || "white-light"
        } ${className} ${purpleGradient && "btn_purple_gradient"} ${
          disabled && "btn_disabled"
        }`}
      >
        <figure className="img-box-two">
          <img src={plusIcon} alt="" className="img" />
        </figure>
        {children}
      </button>
    );
  }
  if (type === "btn-cancel") {
    return (
      <button
        style={style}
        onClick={() => {
          !disabled && !loading && onClick && onClick();
        }}
        className={`raven-btn btn-${color || "green-light"} btn-rounded text-${
          textColor || "white-light"
        } ${className} ${purpleGradient && "btn_purple_gradient"} ${
          disabled && "btn_disabled"
        }`}
      >
        <figure className="img-box-two img-cancel">
          <img src={timesIcon} alt="" className="img" />
        </figure>
        {children}
      </button>
    );
  }

  if (type === "btn-icon") {
    return (
      <button
        style={style}
        onClick={() => {
          !disabled && !loading && onClick && onClick();
        }}
        className={`raven-btn btn-icon  ${
          size === "small" ? "btn-sm" : size === "big" ? "btn-lg" : "btn-md"
        } btn-${color || "green-light"} text-${
          textColor || "white-light"
        } ${className} ${purpleGradient && "btn_purple_gradient"} ${
          disabled && "btn_disabled"
        } `}
      >
        {label}
        <figure className="img-box">
          <img src={arrowRightImg} alt="" className="img" />
        </figure>
        {children}
      </button>
    );
  }
  return (
    <button
      style={style}
      onClick={() => {
        !disabled && !loading && onClick && onClick();
      }}
      className={`raven-btn   ${
        size === "small" ? "btn-sm" : size === "big" ? "btn-lg" : "btn-md"
      } btn-${color || "green-light"} text-${
        textColor || "white-light"
      } ${className} ${purpleGradient && "btn_purple_gradient"} ${
        disabled && "btn_disabled"
      } ${
        loading && size === "small"
          ? "loader-sm"
          : size === "big"
          ? "loader-lg"
          : "loader-md"
      }`}
    >
      {loading ? <></> : children}

      <span
        style={{
          visibility: loading ? "hidden" : "visible",
        }}
      >
        {" "}
        {label}
      </span>

      {loading && (
        <div
          className="loader-wrap"
          style={{
            display: "flex",
            cursor: "not-allowed",
            alignItems: "center",
            gap: loaderText ? "0.8rem" : "0",
            justifyContent: "center",
            position: "absolute",
            top: 0,
            width: "100%",
            height: "100%",
          }}
        >
          {loaderText && <p>{loaderText}</p>}
          <div className="spin">
            {" "}
            <p
              className={`spintula spintula-arc-${color || "green-light"}`}
            ></p>
          </div>
          {/* 
          <ColorRing
            visible={true}
            height={"100"}
            width={"100"}
            ariaLabel="blocks-loading"
            wrapperClass="blocks-wrapper"
            colors={[
              "#ffffff99",
              "#ffffff99",
              "#ffffff99",
              "#ffffff99",
              "#ffffff99",
            ]}
          /> */}
        </div>
      )}
    </button>
  );
};
export default RazorButton;
